import { Injectable } from '@angular/core';
import { ChatMessageToSendDto } from '../models/dto/chat-message-to-send.dto';
import { ChatTypeEnum } from '../models/enum/chat-type.enum';

@Injectable()
export class ChatMessageToSendService {
  messages: ChatMessageToSendDto[] = [];

  constructor() { }

  pushMessage(message: ChatMessageToSendDto): void {
    let msg = this.messages.find((m) => m.type == message.type && m.id == message.id)
    if (msg) msg.text = message.text;
    else this.messages.push(message);
  }

  getMessage(chatType: ChatTypeEnum, chatId: string): string {
    let msg = this.messages.find((m) => m.type == chatType && m.id == chatId)
    if (msg) return msg.text;
    else return '';
  }

  removeMessage(chatType: ChatTypeEnum, chatId: string): void {
    const index = this.messages.findIndex((m) => m.type == chatType && m.id == chatId);
    if (index >= 0)
      this.messages.splice(index, 1);
  }
}
